// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyDjSklqyrEMLhVsT7IZV4HfV9qZjD8kbSI",
  authDomain: "pickaago-testbench.firebaseapp.com",
  projectId: "pickaago-testbench",
  storageBucket: "pickaago-testbench.firebasestorage.app",
  messagingSenderId: "895047832269",
  appId: "1:895047832269:web:9d522f7cc81fb86dcb0f84",
  measurementId: "G-R7PDPLC1SV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
const analytics = getAnalytics(app);










